export default function flattenStatTypes(statType) {
  const output = [{ label: statType.label, data: false, skipped: false }];
  if (statType?.associates?.length) {
    statType.associates.forEach((a) => {
      output.push({ label: a, data: false, skipped: false });
    });
  }
  return output;
}
